import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SidebarStateService {
  private _isCollapsed = new BehaviorSubject<boolean>(false);
  private _activeItemId = new BehaviorSubject<number | null>(null);
  private _isMobile = new BehaviorSubject<boolean>(false);

  isCollapsed$ = this._isCollapsed.asObservable();
  activeItemId$ = this._activeItemId.asObservable();
  isMobile$ = this._isMobile.asObservable();

  constructor() {
    // Load saved state from localStorage
    const savedCollapsedState = localStorage.getItem('sidebarCollapsed');
    const savedActiveItemId = localStorage.getItem('activeItemId');

    if (savedCollapsedState) {
      this._isCollapsed.next(JSON.parse(savedCollapsedState));
    }
    if (savedActiveItemId) {
      this._activeItemId.next(JSON.parse(savedActiveItemId));
    }

    // Initialize mobile state
    this.checkScreenSize();
    window.addEventListener('resize', this.checkScreenSize.bind(this));
  }

  private checkScreenSize() {
    const isMobile = window.innerWidth < 768; // Bootstrap's md breakpoint
    this._isMobile.next(isMobile);
    
    // Auto-collapse sidebar on mobile
    if (isMobile && !this._isCollapsed.value) {
      this.collapse(true);
    }
  }

  toggleSidebar() {
    const newState = !this._isCollapsed.value;
    this._isCollapsed.next(newState);
    localStorage.setItem('sidebarCollapsed', JSON.stringify(newState));
  }

  collapse(state: boolean) {
    this._isCollapsed.next(state);
    localStorage.setItem('sidebarCollapsed', JSON.stringify(state));
  }

  setActiveItem(id: number) {
    this._activeItemId.next(id);
    localStorage.setItem('activeItemId', JSON.stringify(id));
  }
}